export default () => {
  $('.gallery-one__slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.gallery-one__slider-nav',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          dots: true,
          infinite: false,
          fade: false
        }
      }
    ]
  });
  $(".gallery-one__slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".gallery-one__slider-for",
    arrows: false,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true
  });

  $(".one-news__slider").slick({
    slidesToShow: 1,
    dots: true,
    arrows: true,
    prevArrow: '<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 8 16"><path d="M0.288,7.185 L6.326,0.310 C6.710,-0.127 7.333,-0.127 7.717,0.310 C8.100,0.747 8.100,1.456 7.717,1.894 L2.374,7.977 L7.716,14.060 C8.100,14.498 8.100,15.207 7.716,15.644 C7.333,16.081 6.710,16.081 6.326,15.644 L0.288,8.769 C0.096,8.550 -0.000,8.263 -0.000,7.977 C-0.000,7.690 0.096,7.404 0.288,7.185 Z" /></svg></span>',
    nextArrow: '<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 3 6"><path d="M2.892,3.282 L0.628,5.875 C0.484,6.040 0.250,6.040 0.106,5.875 C-0.038,5.710 -0.038,5.443 0.106,5.278 L2.110,2.983 L0.106,0.689 C-0.038,0.524 -0.038,0.256 0.106,0.092 C0.250,-0.073 0.484,-0.073 0.628,0.092 L2.892,2.685 C2.964,2.767 3.000,2.875 3.000,2.983 C3.000,3.092 2.964,3.200 2.892,3.282 Z" /></svg></span>',
    autoplay: true,
    autoplaySpeed: 10000,
    customPaging: function (slider, i) {
      return `<svg class="circle-box" viewbox="0 0 33.83098862 33.83098862" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><circle class="circle" stroke="#e90e8b" stroke-width="2" stroke-dasharray="0,200" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" /></svg>`;
    },
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false
        }
      }
    ]
  });

  if ($('.production__slider').length) {
    $(".production__slider").each(function(index, element) {
      $(element).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $(element).find('.production__slider-controls').find('.production__slider-controlsPrev').html('<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="7" height="13" viewBox="0 0 8 16"><path d="M0.288,7.185 L6.326,0.310 C6.710,-0.127 7.333,-0.127 7.717,0.310 C8.100,0.747 8.100,1.456 7.717,1.894 L2.374,7.977 L7.716,14.060 C8.100,14.498 8.100,15.207 7.716,15.644 C7.333,16.081 6.710,16.081 6.326,15.644 L0.288,8.769 C0.096,8.550 -0.000,8.263 -0.000,7.977 C-0.000,7.690 0.096,7.404 0.288,7.185 Z" /></svg></span>'),
        nextArrow: $(element).find('.production__slider-controls').find('.production__slider-controlsNext').html('<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="7" height="13" viewBox="0 0 3 6"><path d="M2.892,3.282 L0.628,5.875 C0.484,6.040 0.250,6.040 0.106,5.875 C-0.038,5.710 -0.038,5.443 0.106,5.278 L2.110,2.983 L0.106,0.689 C-0.038,0.524 -0.038,0.256 0.106,0.092 C0.250,-0.073 0.484,-0.073 0.628,0.092 L2.892,2.685 C2.964,2.767 3.000,2.875 3.000,2.983 C3.000,3.092 2.964,3.200 2.892,3.282 Z" /></svg></span>'),
        centerMode: true,
        centerPadding: '19%',
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              centerPadding: '13%',
            }
          },
          {
            breakpoint: 1200,
            settings: {
              centerPadding: '0',
            }
          }
        ]
      });
      const itemProducts = $(element).find(".production__slider-item").length;
      if (itemProducts < 2) {
        $(element).addClass('hide-arrows');
      } 
    });
  }

  $(".history__nav").slick({
    slidesToShow: 13,
    slidesToScroll: 1,
    asNavFor: ".history__for",
    arrows: true,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: '0',
    prevArrow: '<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 8 16"><path d="M0.288,7.185 L6.326,0.310 C6.710,-0.127 7.333,-0.127 7.717,0.310 C8.100,0.747 8.100,1.456 7.717,1.894 L2.374,7.977 L7.716,14.060 C8.100,14.498 8.100,15.207 7.716,15.644 C7.333,16.081 6.710,16.081 6.326,15.644 L0.288,8.769 C0.096,8.550 -0.000,8.263 -0.000,7.977 C-0.000,7.690 0.096,7.404 0.288,7.185 Z" /></svg></span>',
    nextArrow: '<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 3 6"><path d="M2.892,3.282 L0.628,5.875 C0.484,6.040 0.250,6.040 0.106,5.875 C-0.038,5.710 -0.038,5.443 0.106,5.278 L2.110,2.983 L0.106,0.689 C-0.038,0.524 -0.038,0.256 0.106,0.092 C0.250,-0.073 0.484,-0.073 0.628,0.092 L2.892,2.685 C2.964,2.767 3.000,2.875 3.000,2.983 C3.000,3.092 2.964,3.200 2.892,3.282 Z" /></svg></span>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 9,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });
  $(".history__for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".history__nav"
  });

  $('.product-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-nav'
  });
  $(".product-nav").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: ".product-for",
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    prevArrow: '<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="4" viewBox="0 0 5.969 3"><path d="M2.673,2.892 L0.093,0.628 C-0.071,0.484 -0.071,0.250 0.093,0.106 C0.257,-0.038 0.523,-0.038 0.687,0.106 L2.970,2.110 L5.253,0.106 C5.417,-0.038 5.683,-0.038 5.847,0.106 C6.011,0.250 6.011,0.484 5.847,0.628 L3.267,2.892 C3.185,2.964 3.078,3.000 2.970,3.000 C2.862,3.000 2.755,2.964 2.673,2.892 Z"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="4" viewBox="0 0 5.969 3"><path d="M2.673,2.892 L0.093,0.628 C-0.071,0.484 -0.071,0.250 0.093,0.106 C0.257,-0.038 0.523,-0.038 0.687,0.106 L2.970,2.110 L5.253,0.106 C5.417,-0.038 5.683,-0.038 5.847,0.106 C6.011,0.250 6.011,0.484 5.847,0.628 L3.267,2.892 C3.185,2.964 3.078,3.000 2.970,3.000 C2.862,3.000 2.755,2.964 2.673,2.892 Z"/></svg></span>',
    responsive: [
      {
        breakpoint: 1439,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 767,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 3,
          arrows: false
        }
      }
    ]
  });

  $(".news-slider__list").slick({
    slidesToShow: 3,
    dots: true,
    arrows: true,
    prevArrow: '<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 8 16"><path d="M0.288,7.185 L6.326,0.310 C6.710,-0.127 7.333,-0.127 7.717,0.310 C8.100,0.747 8.100,1.456 7.717,1.894 L2.374,7.977 L7.716,14.060 C8.100,14.498 8.100,15.207 7.716,15.644 C7.333,16.081 6.710,16.081 6.326,15.644 L0.288,8.769 C0.096,8.550 -0.000,8.263 -0.000,7.977 C-0.000,7.690 0.096,7.404 0.288,7.185 Z" /></svg></span>',
    nextArrow: '<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 3 6"><path d="M2.892,3.282 L0.628,5.875 C0.484,6.040 0.250,6.040 0.106,5.875 C-0.038,5.710 -0.038,5.443 0.106,5.278 L2.110,2.983 L0.106,0.689 C-0.038,0.524 -0.038,0.256 0.106,0.092 C0.250,-0.073 0.484,-0.073 0.628,0.092 L2.892,2.685 C2.964,2.767 3.000,2.875 3.000,2.983 C3.000,3.092 2.964,3.200 2.892,3.282 Z" /></svg></span>',
    appendArrows: $(".news-slider__controls"),
    autoplay: true,
    autoplaySpeed: 10000,
    customPaging: function (slider, i) {
      return `<svg class="circle-box" viewbox="0 0 33.83098862 33.83098862" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><circle class="circle" stroke="#e90e8b" stroke-width="2" stroke-dasharray="0,200" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" /></svg>`;
    },
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  $(".products-slider__list").slick({
    slidesToShow: 3,
    dots: true,
    arrows: true,
    prevArrow: '<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 8 16"><path d="M0.288,7.185 L6.326,0.310 C6.710,-0.127 7.333,-0.127 7.717,0.310 C8.100,0.747 8.100,1.456 7.717,1.894 L2.374,7.977 L7.716,14.060 C8.100,14.498 8.100,15.207 7.716,15.644 C7.333,16.081 6.710,16.081 6.326,15.644 L0.288,8.769 C0.096,8.550 -0.000,8.263 -0.000,7.977 C-0.000,7.690 0.096,7.404 0.288,7.185 Z" /></svg></span>',
    nextArrow: '<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 3 6"><path d="M2.892,3.282 L0.628,5.875 C0.484,6.040 0.250,6.040 0.106,5.875 C-0.038,5.710 -0.038,5.443 0.106,5.278 L2.110,2.983 L0.106,0.689 C-0.038,0.524 -0.038,0.256 0.106,0.092 C0.250,-0.073 0.484,-0.073 0.628,0.092 L2.892,2.685 C2.964,2.767 3.000,2.875 3.000,2.983 C3.000,3.092 2.964,3.200 2.892,3.282 Z" /></svg></span>',
    appendArrows: $(".products-slider__controls"),
    autoplay: true,
    autoplaySpeed: 10000,
    customPaging: function (slider, i) {
      return `<svg class="circle-box" viewbox="0 0 33.83098862 33.83098862" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><circle class="circle" stroke="#e90e8b" stroke-width="2" stroke-dasharray="0,200" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" /></svg>`;
    },
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  $(".catalog-slider__list").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: true,
    prevArrow: '<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 8 16"><path d="M0.288,7.185 L6.326,0.310 C6.710,-0.127 7.333,-0.127 7.717,0.310 C8.100,0.747 8.100,1.456 7.717,1.894 L2.374,7.977 L7.716,14.060 C8.100,14.498 8.100,15.207 7.716,15.644 C7.333,16.081 6.710,16.081 6.326,15.644 L0.288,8.769 C0.096,8.550 -0.000,8.263 -0.000,7.977 C-0.000,7.690 0.096,7.404 0.288,7.185 Z" /></svg></span>',
    nextArrow: '<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 3 6"><path d="M2.892,3.282 L0.628,5.875 C0.484,6.040 0.250,6.040 0.106,5.875 C-0.038,5.710 -0.038,5.443 0.106,5.278 L2.110,2.983 L0.106,0.689 C-0.038,0.524 -0.038,0.256 0.106,0.092 C0.250,-0.073 0.484,-0.073 0.628,0.092 L2.892,2.685 C2.964,2.767 3.000,2.875 3.000,2.983 C3.000,3.092 2.964,3.200 2.892,3.282 Z" /></svg></span>',
    appendArrows: $(".catalog-slider__controls"),
    autoplay: true,
    autoplaySpeed: 10000,
    focusOnSelect: true,
    customPaging: function (slider, i) {
      return `<svg class="circle-box" viewbox="0 0 33.83098862 33.83098862" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><circle class="circle" stroke="#e90e8b" stroke-width="2" stroke-dasharray="0,200" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" /></svg>`;
    },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  
  // const mainCount = $(".main-slider__item").length;
  // if (mainCount > 10) {
  //   $(".main-slider__all").text(mainCount);
  // } else {
  //   $(".main-slider__all").text('0' + mainCount);
  // }
  // $(".main-slider").slick({
  //   slidesToShow: 1,
  //   dots: true,
  //   arrows: true,
  //   prevArrow: $('.main-slider__arrows').find('.main-slider__arrows-prev').html('<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="7" height="13" viewBox="0 0 8 16"><path d="M0.288,7.185 L6.326,0.310 C6.710,-0.127 7.333,-0.127 7.717,0.310 C8.100,0.747 8.100,1.456 7.717,1.894 L2.374,7.977 L7.716,14.060 C8.100,14.498 8.100,15.207 7.716,15.644 C7.333,16.081 6.710,16.081 6.326,15.644 L0.288,8.769 C0.096,8.550 -0.000,8.263 -0.000,7.977 C-0.000,7.690 0.096,7.404 0.288,7.185 Z" /></svg></span>'),
  //   nextArrow: $('.main-slider__arrows').find('.main-slider__arrows-next').html('<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="7" height="13" viewBox="0 0 3 6"><path d="M2.892,3.282 L0.628,5.875 C0.484,6.040 0.250,6.040 0.106,5.875 C-0.038,5.710 -0.038,5.443 0.106,5.278 L2.110,2.983 L0.106,0.689 C-0.038,0.524 -0.038,0.256 0.106,0.092 C0.250,-0.073 0.484,-0.073 0.628,0.092 L2.892,2.685 C2.964,2.767 3.000,2.875 3.000,2.983 C3.000,3.092 2.964,3.200 2.892,3.282 Z" /></svg></span>'),
  //   autoplay: true,
  //   autoplaySpeed: 10000,
  //   fade: true,
  //   customPaging: function (slider, i) {
  //     return `<svg class="circle-box" viewbox="0 0 33.83098862 33.83098862" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><circle class="circle" stroke="#e90e8b" stroke-width="2" stroke-dasharray="0,200" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" /></svg>`;
  //   },
  // });
  // $('.main-slider__current').each(function (index, element) {
  //   const slideCurrent = $(element).parents('.slick-slide').attr('data-slick-index');
  //   const valueCurrent = parseInt(slideCurrent, 10) + 1;
  //   if (valueCurrent < 10) {
  //     $(element).text('0' + valueCurrent);
  //   } else {
  //     $(element).text(valueCurrent);
  //   }
  // });

  const mainCount = $(".main-slider__item").length;
  if (mainCount > 10) {
    $(".main-slider__all").text(mainCount);
  } else {
    $(".main-slider__all").text('0' + mainCount);
  }
  $(".main-slider").slick({
    dots: true,
    fade: true,
    arrows: true,
    prevArrow: '<span class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 8 16"><path d="M0.288,7.185 L6.326,0.310 C6.710,-0.127 7.333,-0.127 7.717,0.310 C8.100,0.747 8.100,1.456 7.717,1.894 L2.374,7.977 L7.716,14.060 C8.100,14.498 8.100,15.207 7.716,15.644 C7.333,16.081 6.710,16.081 6.326,15.644 L0.288,8.769 C0.096,8.550 -0.000,8.263 -0.000,7.977 C-0.000,7.690 0.096,7.404 0.288,7.185 Z" /></svg></span>',
    nextArrow: '<span class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="8" height="16" viewBox="0 0 3 6"><path d="M2.892,3.282 L0.628,5.875 C0.484,6.040 0.250,6.040 0.106,5.875 C-0.038,5.710 -0.038,5.443 0.106,5.278 L2.110,2.983 L0.106,0.689 C-0.038,0.524 -0.038,0.256 0.106,0.092 C0.250,-0.073 0.484,-0.073 0.628,0.092 L2.892,2.685 C2.964,2.767 3.000,2.875 3.000,2.983 C3.000,3.092 2.964,3.200 2.892,3.282 Z" /></svg></span>',
    appendArrows: $(".main-slider-controls"),
    autoplay: true,
    autoplaySpeed: 10000,
    customPaging: function (slider, i) {
      return `<svg class="circle-box" viewbox="0 0 33.83098862 33.83098862" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><circle class="circle" stroke="#e90e8b" stroke-width="2" stroke-dasharray="0,200" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" /></svg>`;
    },
    asNavFor: '.main-slider__nav',
  });
  $(".main-slider__nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".main-slider",
    arrows: false,
    focusOnSelect: true,
  });

  $('.main-slider__current').each(function (index, element) {
    const slideCurrent = $(element).parents('.slick-slide').attr('data-slick-index');
    const valueCurrent = parseInt(slideCurrent, 10) + 1;
    if (valueCurrent < 10) {
      $(element).text('0' + valueCurrent);
    } else {
      $(element).text(valueCurrent);
    }
  });

}


// WEBPACK FOOTER //
// app/scripts/components/sliders.js